import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { getImagePath } from '../../helpers/common';
import ImageWrapper from '../ImageWrapper';
import { useSelector } from 'react-redux';
import UpLeftArrow from '../svg-icons/UpLeftArrow';
import { useRouter } from 'next/router';

interface NewsCardProps {
  title: string;
  name: string;
  description: string;
  link: string;
  imageUrl: string;
}

const NewsCard = (newsItem: NewsCardProps) => {
  const { t } = useTranslation('common');
  const { locale } = useRouter();
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const formattedLink = newsItem.link.startsWith('http')
    ? newsItem.link
    : `https://${newsItem.link}`;

  return (
    <CardContainer locale={locale}>
      <ImageWrapper
        src={getImagePath(newsItem.imageUrl)}
        alt={`${newsItem.name} - Nawy Cover`}
        width={170}
        height={50}
        className="article-cover"
        imageSize={isMobile ? 'low' : 'high'}
      />
      <div className="article-data">
        <h3 className="news-header">{newsItem.title}</h3>
        <p>{newsItem.description}</p>
        <a href={formattedLink} target="_blank" rel="nofollow">
          <UpLeftArrow /> {t('know_more')}
        </a>
      </div>
    </CardContainer>
  );
};

const CardContainer = styled.div<any>`
  min-width: 357px;
  height: 405px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0px 0px 7px 1px rgba(169, 169, 169, 0.22);
  cursor: pointer;
  .article-cover {
    position: relative;
    width: 100%;
    height: 200px;
    border-radius: 18px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    object-fit: cover;
  }

  .article-data {
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    gap: 8px;

    .news-header {
      color: #212431;
      font-family: materialSemiBold;
      font-size: 20px;
      line-height: 140%;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      min-height: 84px;
    }

    p {
      color: #373c43;
      font-family: materialRegular;
      font-size: 16px;
      min-height: 40px;
      max-height: 80px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }

    a {
      display: flex;
      gap: 4px;
      color: #215a8e;
      font-family: materialMedium;
      font-size: 18px;
      margin-top: 8px;
      svg {
        transform: ${props => (props.locale === 'ar' ? 'scaleX(-1)' : '')};
      }
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    width: 100%;
    height: fit-content;
    position: relative;

    .article-data {
      .news-header {
        font-size: 18px;
        -webkit-line-clamp: 2;
        min-height: unset;
      }

      p {
        font-size: 14px;
        -webkit-line-clamp: 3;
        min-height: unset;
      }

      a {
        font-size: 16px;
      }
    }
  }
`;

export default NewsCard;
